import { OrganizationMetadataDTO } from '@om1/falcon-api'

export interface GeneralSettingsState {
    loading: boolean
    saving: boolean
    organizationMetadata: OrganizationMetadataDTO | null
}

export const initialGeneralSettingsState: GeneralSettingsState = {
    loading: true,
    saving: false,
    organizationMetadata: null
}
